import apiClient from "@/services/apiClient";

const axios = require('axios');

export default {
    methods: {
        async doSearch(params) {
            const { data } = await axios.post(`${process.env.VUE_APP_INVENTORY_API_URL}/discogs/search`, params);

            return data;
        },
        async getRelease(releaseId) {
            const { data } = await axios.get(`${process.env.VUE_APP_INVENTORY_API_URL}/discogs/release/${releaseId}`);

            return data;
        },
        async addNoMatch(itemId) {
            const { data } = await apiClient.post(`${process.env.VUE_APP_INVENTORY_API_URL}/discogs/attempt/${itemId}`, {});

            return data;
        },
        async addMatch(itemId, discogsId) {
            const { data } = await apiClient.post(`${process.env.VUE_APP_INVENTORY_API_URL}/discogs/release`, { itemId: itemId, discogsId: discogsId });

            return data;
        }
    }
}